import { CommonDialogs } from "@mcleod/common";
import { BlurEvent, DataSourceMode, LookupModelSelectionEvent } from "@mcleod/components";
import { Api, LogManager } from "@mcleod/core";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutMobileCommReefer } from "./autogen/AutogenLayoutMobileCommReefer";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommReefer");

const viewMCReeferCodeURL = "lme/dispatch/mobilecomm/MobileCommReefer?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "reefer",
    screenName: "Mobile Comm Reefer",
    navigateToUrl: viewMCReeferCodeURL
};

export class MobileCommReefer extends AutogenLayoutMobileCommReefer {

    async onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);

        this.textboxTrailer.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.trailerIdModelSelection(event);
        });

        this.mainDataSource.doBeforeDataSourcePost = async () => {
            const refTotalFuel = this.mainDataSource.activeRow?.get("ref_total_fuel");
            const refCurrentFuel = this.mainDataSource.activeRow?.get("ref_current_fuel");

            if (!this.isCurrentFuelValid(refTotalFuel, refCurrentFuel)) {
                CommonDialogs.showDialog("Current fuel level cannot be greater than total fuel capacity.").finally(() => {
                    this.textboxCurrentFuelLevel.focus();
                });

                return false;
            } else {
                return true;
            }
        };
    }

     private async trailerIdModelSelection(event: LookupModelSelectionEvent) {
        if (this.mainDataSource.mode != DataSourceMode.SEARCH && event.hasSelection() === true) {
            const response = await Api.search("lme/dispatch/mobilecomm/get-update-reefer-trailer", {
                "trailer": event.selection?.get("id"),
                "excluded_reefer": this.mainDataSource.activeRow?.get("id")
            });

            if (response.data[0]?.reefer_list === undefined) {
                this.mainDataSource.activeRow.set("sync_reefers", false);
                return;
            }

            const userConfirmed = await this.confirmChangeReefer(response.data[0].reefer_list);
            this.mainDataSource.activeRow.set("sync_reefers", userConfirmed);
            if (!userConfirmed) {
                const origRow = this.mainDataSource.activeRow.originalData;
                this.textboxTrailer.text = origRow["trailer"];
                this.textboxTrailer.focus();
            }
        }
    }

    private async confirmChangeReefer(defaultReeferList: any): Promise<boolean> {
        return await CommonDialogs.showYesNo(
            `Only one trailer can be associated with a reefer, selecting "Yes" will remove the selected trailer from reefer(s): ${this.getReeferList(defaultReeferList)}`,
            "Change Trailer Reefer"
        );
    }

    private getReeferList(default_reefer_list: any): string {
        let result = "\n\n";
        for (let i = 0; i < default_reefer_list.length; i++) {
            result += default_reefer_list[i].reefer_id + "\n";
        }
        return result;
    }

    async validateFuelFieldsOnBlur(event: BlurEvent): Promise<boolean> {
        const refTotalFuel = this.mainDataSource.activeRow?.get("ref_total_fuel");
        const refCurrentFuel = this.mainDataSource.activeRow?.get("ref_current_fuel");

        if (!this.isCurrentFuelValid(refTotalFuel, refCurrentFuel)) {
            this.textboxCurrentFuelLevel.validationWarning = "Current fuel level cannot be greater than total fuel capacity.";
            await this.textboxCurrentFuelLevel.focus();
            return false;
        } else {
            return true;
        }
    }

    private isCurrentFuelValid(refTotalFuel: any, refCurrentFuel: any): boolean {
        // Return false if both fields are populated and current fuel is greater than total fuel
        if (refTotalFuel != null && refCurrentFuel != null && refCurrentFuel > refTotalFuel) {
            return false;
        }

        return true;
    }
}
